<div class="tenantsetting-tree-page" *ngIf="!loading">

    <div class="tree-pane">
        <input class="searchbox" type="text" [ngModel]="searchText" (ngModelChange)="onSearchTextChanged($event)"
            placeholder="{{ 'TENANTSETTING.TREE.SEARCH.PLACEHOLDER' | translate }}" />

        <div class="tree-scroll">
            <ng-container *ngFor="let node of filteredRoot?.children" [ngTemplateOutlet]="nodeTemplate"
                [ngTemplateOutletContext]="{ node: node, depth: 0 }">
            </ng-container>
        </div>
    </div>

    <div class="detail-pane">
        <div class="detail-header" *ngIf="selectedNode">
            <h2>{{ selectedNode.caption }}</h2>
        </div>

        <div class="detail-empty" *ngIf="!selectedNode">
            {{ 'TENANTSETTING.TREE.SELECTCATEGORY' | translate }}
        </div>

        <div class="setting-list" *ngIf="selectedNode">
            <shared-tenantsetting-value *ngFor="let entry of selectedNode.entries" [setting]="entry.setting"
                [readonly]="iReadonly" (saved)="onSettingSaved($event)">
            </shared-tenantsetting-value>

            <div class="detail-empty" *ngIf="selectedNode.entries.length === 0">
                {{ 'TENANTSETTING.TREE.SELECTCHILDCATEGORY' | translate }}
            </div>
        </div>
    </div>

</div>

<div class="tenantsetting-tree-loading" *ngIf="loading">
    {{ 'GENERAL.LOADING.CAPTION' | translate }}
</div>

<ng-template #nodeTemplate let-node="node" let-depth="depth">
    <div class="tree-node" [class.selected]="node === selectedNode" [style.paddingLeft.px]="depth * 16 + 8">
        <span class="expander" *ngIf="node.children.length > 0" (click)="toggleExpanded(node, $event)">
            <i class="fa" [ngClass]="node.expanded ? 'fa-caret-down' : 'fa-caret-right'"></i>
        </span>
        <span class="expander-placeholder" *ngIf="node.children.length === 0"></span>

        <span class="node-caption" (click)="selectNode(node)">
            {{ node.caption }}
            <span class="node-count" *ngIf="node.totalEntryCount() > 0">{{ node.totalEntryCount() }}</span>
        </span>
    </div>

    <ng-container *ngIf="node.expanded">
        <ng-container *ngFor="let child of node.children" [ngTemplateOutlet]="nodeTemplate"
            [ngTemplateOutletContext]="{ node: child, depth: depth + 1 }">
        </ng-container>
    </ng-container>
</ng-template>